import { RELATED_CATEGORY_FEATURED_STORES_VIEW } from './types';

export const triggerRelatedCategoryFeaturedStoresAreViewed = (category, suspendedMerchantName) => ({
  type: RELATED_CATEGORY_FEATURED_STORES_VIEW,
  category,
  suspendedMerchantName,
});
